import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { AuthTokenService } from '../services/auth-token.service';
import { DconfigCoreSettings } from '../dconfig-core.settings';

@Injectable({
  providedIn: 'root'
})
export class AuthHttpInterceptorService implements HttpInterceptor {

  constructor(private tokenService: AuthTokenService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Adding Ajax to header so that server knows that the call is ajax call
    const cloned = req.clone({
      headers: req.headers.set("Ajax", "true").set("Access-Control-Allow-Origin", DconfigCoreSettings.API_ENDPOINT),
      method: req.method
    });
    req = cloned;
    // Adding the token when the user is authenticated
    if (this.tokenService.isAuth) {
      const idToken = this.tokenService.getToken();
      if (idToken) {
        const cloned2 = req.clone({
          headers: req.headers.set("Authorization", "Bearer " + idToken),
          method: req.method
        });
        req = cloned2;
      }
    }
    return next.handle(req).pipe(
      tap((event) => {
        //if (event instanceof HttpResponse) {
        //  // do stuff with response if you want
        //}
      }, (response: any) => {
        if (response instanceof HttpErrorResponse) {
          if (response.status === 401) {
            if (this.tokenService._401Handler != undefined) {
              this.tokenService._401Handler();
            } else {
              alert('You do not have enough permissions to request this resource or do this action.');
            }
          } else if (response.status == 403) {
            if (this.tokenService._403Handler != undefined) {
              this.tokenService._403Handler();
            } else {
              alert('You do not have enough permissions to request this resource or do this action.');
            }
          }
        }
      })
    );
  }


}
